// React&NextJS
import React from 'react'
// Styles
import s from '../Authentication.module.scss'
// Components
import { Container } from '../../../core/container/Container'
import { Text } from '../../../core/text/Text'
import { WhiteBox } from '../../../core/whiteBox/WhiteBox'
import { Button } from '../../../core/button/Button'

const ErrorComponent = ({ closeButton = null, setState }) => {
    return (
        <Container>
            <WhiteBox className={s.container}>
                {closeButton}

                <div>
                    <Text variant="h2">Upp kom villa</Text>
                    <Text variant="p-18">Reyndu aftur að skrá þig inn.</Text>
                </div>
                <Button
                    onClick={() => {
                        setState(0)
                    }}
                    className={s.button}
                >
                    Skrá inn
                </Button>
            </WhiteBox>
        </Container>
    )
}

export default ErrorComponent
